import React from 'react'
import Loader from '../Common/Loader'
import { getFormattedNumber } from '../utils/textUtils'
import { Link } from 'react-router-dom'

const RequisitionReport = ({ resPacket, loading }) => {

    if (loading) {
        return <Loader />
    }

    if (resPacket?.length === 0) {
        return "No Records Found"
    }

    const calTaxAmount = (data) => {
        if (data.taxRate > 0) {
            return (((parseFloat(data.taxRate) + 100) * parseFloat(data.itemRate) * data.qty) / 100).toFixed(2);
        }
        return (parseFloat(data.itemRate) * data.qty).toFixed(2);
    }

    return (
        <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr>
                        <td>SNO.</td>
                        <td>REQUISITION DATE</td>
                        <td>REQUISITION NUMBER</td>
                        <td>BATCH NO</td>
                        <td>DEPARTMENT</td>
                        <td>MFG DATE</td>
                        <td>EXPIRY DATE</td>
                        <td>ITEM CODE</td>
                        <td>ITEM NAME</td>
                        <td>ITEM CATEGORY</td>
                        <td>ITEM SUB CATEGORY</td>
                        <td className='text-center'>QTY</td>
                        <td>UOM</td>
                        <td>ITEM RATE</td>
                        <td>AMOUNT</td>
                        <td>TAX RATE</td>
                        <td>TOTAL AMOUNT</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {resPacket.map((row, i) => (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td className='white-space-pre'>{row.requisitionDate}</td>
                            <td>
                                <Link to={`/requisition/${row.requisitionUuid}`} target="_blank">
                                    {row.requisitionNumber}
                                </Link>
                            </td>
                            <td>{row.batchNumber}</td>
                            <td>{row.department}</td>
                            <td>{row.mfgDate}</td>
                            <td>{row.expiryDate}</td>
                            <td>{row.itemCode}</td>
                            <td>{row.itemName}</td>
                            <td>{row.category}</td>
                            <td>{row.subCategory}</td>
                            <td className='text-right'>{getFormattedNumber(row.qty)}</td>
                            <td>{row.uom}</td>
                            <td>{parseFloat(row.itemRate).toFixed(3)}</td>
                            <td>{(parseFloat(row.itemRate) * parseFloat(row.qty)).toFixed(2)}</td>
                            <td>{row.taxRate}</td>
                            <td>{calTaxAmount(row)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default RequisitionReport;
